import api from './api';

export const getPostcodeLocation = async (postcode) => {
  const { data } = await api.get(`/postcode/${postcode}/location`);
  return data;
};
